import ProjectUI from '../../../reusables/ProjectUI/ProjectUI';
import picture3 from './Picture3.jpg';

export default function Project2() {
    return (
        <ProjectUI
            projectImage={ [{
                title:"Identification of Mass Distribution of a Live Human",
                src: picture3,
            }] }
        />
    )
}
